import { createSelector } from '@ngrx/store';
import * as fromInformativePages from '../informative-page/informative-page.reducer';
import { selectDashboardState } from '../dashboard.selectors';

export const selectInformativePageState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.informativePage
);

export const selectIsLoadingInformativePages = createSelector(
  selectInformativePageState,
  (informativePageState) => informativePageState?.loadingInformativePages
);

export const selectInformativePagesLoaded = createSelector(
  selectInformativePageState,
  (informativePageState) => informativePageState?.informativePagesLoaded
);

export const selectInformativePages = createSelector(selectInformativePageState, fromInformativePages.selectAll);

export const selectSelectedInformativePage = createSelector(
  selectInformativePageState,
  (informativePageState) => informativePageState?.selectedInformativePage
);
